'use strict';

require('../users/CompanyUserStarService.js');
require('../../user/CurrentUserService.js');

function PublicationStarDirective(CompanyUserStarService, CurrentUserService, $stateParams, $translate, $q, growl) {
  return {
    restrict: 'A',
    scope: {
      publication: '=publicationStar',
    },
    link: function($scope, elm) {
      var currentUser;

      $scope.toggleStar = function() {
        if ($scope.publication.starred) {
          CompanyUserStarService.delete({companyId: $stateParams.companyId, userId: currentUser.id, publicationId: $scope.publication.id}, {}, function() {
            growl.addSuccessMessage($translate.instant('publication.star.remove-success'));
            $scope.publication.starred = false;
          }, function() {
            growl.addErrorMessage($translate.instant('publication.star.remove-failure'));
          });
        } else {
          CompanyUserStarService.add({companyId: $stateParams.companyId, userId: currentUser.id, publicationId: $scope.publication.id}, {}, function() {
            growl.addSuccessMessage($translate.instant('publication.star.add-success'));
            $scope.publication.starred = true;
          }, function() {
            growl.addErrorMessage($translate.instant('publication.star.add-failure'));
          });
        }
      };

      CurrentUserService.get().then(function(user) {
        currentUser = user;
        elm.bind('click', $scope.toggleStar);
      });
    }
  };
}

angular.module('dokiv')
  .directive('publicationStar', ['CompanyUserStarService', 'CurrentUserService', '$stateParams', '$translate', '$q', 'growl', PublicationStarDirective]);





//////////////////
// WEBPACK FOOTER
// ./scripts/company/publications/PublicationStarDirective.js
// module id = 392
// module chunks = 0